import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/**
 * @param {{ query?: {
 *   planId?: string,
 *   customerId?: string,
 *   employeeId?: string,
 *   meetingResultId?: string,
 *   status?: 'Active' | 'Completed' | 'Cancelled',
 *   startDate?: string,
 *   endDate?: string,
 *   search?: string,
 *   page?: number,
 *   limit?: number
 * } }} [option]
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.MeetingRecord.GetAll(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ query?: {
 *   planId?: string,
 *   customerId?: string,
 *   employeeId?: string,
 *   meetingResultId?: string,
 *   status?: 'Active' | 'Completed' | 'Cancelled',
 *   startDate?: string,
 *   endDate?: string,
 *   search?: string,
 *   page?: number,
 *   limit?: number
 * } }} [option]
 */
export const GetActive = async (option) => {
  const response = await $api.get(Endpoints.MeetingRecord.GetActive(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ planId: string, notePlainText?: string }} form
 */
export const Start = async (form) => {
  const response = await $api.post(Endpoints.MeetingRecord.Start(), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ notePlainText: string }} form
 * @param {{ params: { id: string } }} option
 */
export const UpdateNote = async (form, option) => {
  const response = await $api.put(
    Endpoints.MeetingRecord.UpdateNote(option),
    form
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ meetingResultId: string, notePlainText?: string }} form
 * @param {{ params: { id: string } }} option
 */
export const Complete = async (form, option) => {
  const response = await $api.post(
    Endpoints.MeetingRecord.Complete(option),
    form
  );
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetAll,
  GetActive,
  Start,
  UpdateNote,
  Complete,
};
